// SPEC-48 to SPEC-50, SPEC-56 · the words of a form section around the
// protocol's: the empty value, a slider's value, why a number or a date was
// refused, the menu and the card of 1.5's consultations, PT first
// (BRAND.md), FR and EN key for key. Field labels,
// options, help and units are src/i18n/bilanProtocol*.ts.

import type { Words } from "../shell";

export const bilanFormPt = {
  /** An empty field, and a slider not moved yet. */
  empty: "—",
  /** EVA's placeholder: out of its maximum, « /10 ». */
  outOf: (max: string) => `/${max}`,
  /** A slider's value. */
  percent: (value: string) => `${value} %`,
  /** What a slider not moved yet says to a screen reader. */
  unset: "Sem valor",
  /** Why a number was refused: the numbers the field takes. */
  wholeRange: (min: string, max: string) => `Um número inteiro de ${min} a ${max}`,
  stepRange: (min: string, max: string, step: string) => `De ${min} a ${max}, de ${step} em ${step}`,
  /** Why a date was refused: the years the field takes. */
  dateRange: (from: string, to: string) => `Uma data entre ${from} e ${to}`,
  /** SPEC-56 · the consultations' menu, before the first line and after it. */
  chooseProfessional: "Escolher profissional…",
  addProfessional: "Adicionar outro profissional…",
  /** The consultations' card with no line yet. */
  noConsults: "Nenhuma consulta registada.",
  /** A line's « × », read by a screen reader: « Retirar Podologista ». */
  removeProfessional: (professional: string) => `Retirar ${professional}`,
} as const;

export const bilanFormFr: Words<typeof bilanFormPt> = {
  empty: "—",
  outOf: (max) => `/${max}`,
  percent: (value) => `${value} %`,
  unset: "Aucune valeur",
  wholeRange: (min, max) => `Un nombre entier de ${min} à ${max}`,
  stepRange: (min, max, step) => `De ${min} à ${max}, par pas de ${step}`,
  dateRange: (from, to) => `Une date entre ${from} et ${to}`,
  chooseProfessional: "Choisir un professionnel…",
  addProfessional: "Ajouter un autre professionnel…",
  noConsults: "Aucune consultation enregistrée.",
  removeProfessional: (professional) => `Retirer ${professional}`,
};

export const bilanFormEn: Words<typeof bilanFormPt> = {
  empty: "—",
  outOf: (max) => `/${max}`,
  percent: (value) => `${value}%`,
  unset: "No value",
  wholeRange: (min, max) => `A whole number from ${min} to ${max}`,
  stepRange: (min, max, step) => `From ${min} to ${max}, in steps of ${step}`,
  dateRange: (from, to) => `A date between ${from} and ${to}`,
  chooseProfessional: "Choose a professional…",
  addProfessional: "Add another professional…",
  noConsults: "No consultation recorded.",
  removeProfessional: (professional) => `Remove ${professional}`,
};
